// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__3Ixyr","inner":"Footer_inner__1WpOl","nextIcon":"Footer_nextIcon__3H9gj","innerLeft":"Footer_innerLeft__3CNBI"};